import { render, staticRenderFns } from "./packingOrder.vue?vue&type=template&id=c9bf5068&scoped=true"
import script from "./packingOrder.vue?vue&type=script&lang=js"
export * from "./packingOrder.vue?vue&type=script&lang=js"
import style0 from "./packingOrder.vue?vue&type=style&index=0&id=c9bf5068&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bf5068",
  null
  
)

export default component.exports